import React from "react";
import { useFieldArray } from "react-hook-form";
import { Button } from "@sscs/ui";
import {
  DeleteForeverIcon as DeleteIcon,
  ArrowLongRightIcon as MappingIcon,
} from "@sscs/ui/icons";
import { ConfirmButton } from "Components";
import { OidcGroupMapping } from "Types";
import GroupName from "../GroupName/GroupName";
import SelectGroup from "../SelectGroup/SelectGroup";
import styles from "./groupMappingFields.module.scss";

const EMPTY_MAPPING: OidcGroupMapping = { group_id: "", mapping: "" };

const GroupMappings = (): React.JSX.Element => {
  const { fields, append, remove } = useFieldArray({
    name: "group_mappings",
  });

  const controlledFields = fields.map((field) => ({
    ...field,
  }));

  const handleAddRow = (event: React.MouseEvent) => {
    event.preventDefault();
    append(EMPTY_MAPPING);
  };

  const handleRemoveRow = (rowIndex: number) => {
    remove(rowIndex);
  };

  return (
    <div className={styles["group-mapping"]}>
      <div>
        {controlledFields.map((groupMapping, index) => (
          <div key={groupMapping.id} className={styles["group-mapping-row"]}>
            <GroupName name={`group_mappings[${index}].mapping`} />
            <MappingIcon className={styles["arrow-icon"]} />
            <SelectGroup name={`group_mappings[${index}].group_id`} />
            <ConfirmButton
              className={styles["delete-action"]}
              color="secondary"
              onClick={() => handleRemoveRow(index)}
              icon={<DeleteIcon />}
            >
              Delete row
            </ConfirmButton>
          </div>
        ))}
      </div>
      <div>
        <Button color="secondary" onClick={handleAddRow}>
          Add mapping
        </Button>
      </div>
    </div>
  );
};

export default GroupMappings;
